// extracted by mini-css-extract-plugin
export default {"container":"linear-regression_container__4v48S"};